import {TeachBlock, TeachBlockPage} from "./types";
const base = process.env.PUBLIC_URL || ``;

export const branch0Aksinya = {
    start: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'patientAksinyaCardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    cabinet: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'patientAnalyzesDefault',
        cardClick: 'patientAksinyaCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    firstAksinyaDoctor: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Надя',
        text: 'Вот знаете доктор, бывают круглые отличницы? Гордость мамы, школы, района, города. Сейчас сами увидите её!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'tuktukAksinya', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAksinyaCardFirst: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AksinyaAnalyzes",
            closeClick: "firstAksinyaDoctor",
            pages: [`${base}/images/patient_aksinya_card1.png`, `${base}/images/patient_aksinya_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAksinyaCard: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AksinyaAnalyzesAfter",
            closeClick: "AksinyaAnalyzesAfter",
            pages: [`${base}/images/patient_aksinya_card1.png`, `${base}/images/patient_aksinya_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktukAksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Тревожный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enterAksinya', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Здравствуйте! Как я рада, что попала к настоящему специалисту! Вы знаете, чтобы не тратить время, скажу так: я много чего изучила, и больше всего, похоже что у меня пароксизмальная ночная гемоглобинурия...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, Проходите, пожалуйста. ", type: "nextStep", gotoStep:'enterAksinya2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAksinya2: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Надя',
        text: 'Это большая редкость! Пароксизмальная ночная гемоглобинурия — редкое заболевание, распространённость которого оценивается до 15,9 случаев на миллион человек во всём мире!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'enterAksinya2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAksinya2Link: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Надя',
        text: '<strong>Paroxysmal Nocturnal Hemoglobinuria. StatPearls // National Library of Medicine. National Center of Biotechnology.</strong><br>Information URL: <br><a href="https://www.ncbi.nlm.nih.gov/books/NBK562292/">https://www.ncbi.nlm.nih.gov/books/NBK562292/</a><br> (дата обращения: 01.08.2025).',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'enterAksinya2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaFirstQuestion: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Знаете...  Мне на биологию подниматься всего три этажа, а ощущаю, как будто я Эверест покорила. Голова часто кружится. А вдруг это пароксизмальная ночная гемоглобинурия... Мне страшно!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить пациентку", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'AksinyaAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestions: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Головокружение", type: "nextStep", gotoStep:'aksinyaQuestion1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Усталость", type: "nextStep", gotoStep:'aksinyaQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Одышка", type: "nextStep", gotoStep:'aksinyaQuestion3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Сон", type: "nextStep", gotoStep:'aksinyaQuestion4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Рацион", type: "nextStep", gotoStep:'aksinyaQuestion5', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestion1: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Если резко встаю! Иногда если не резко - тоже... А иногда, если честно, даже когда сижу...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestion2: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Я все время ее чувствую.. Я даже просыпаюсь и как будто сразу уже устала... Наш край суров, зимой особенно тяжело.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestion3: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Меня освободили от физкультуры, потому что мне надо готовиться к олимпиаде... Да какой мне спорт! Некогда. Но иногда я жалею об этом... Особенно, когда на третий этаж без лифта поднимаюсь с такой одышкой, будто мне лет 100!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestion4: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: '6 часов, стабильно! Но больше мне некогда спать!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaQuestion5: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Я — вегетарианка! Но сейчас как-то аппетита совсем нет ни на что, если честно...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AksinyaAnalyzes: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AksinyaCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAksinyaCardFirst",
            nextClick: "firstAksinyaDoctor",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_aksinya_1_1_table.jpg`],
                [],
                [],
                [],
                []
            ],
            analyzesHeights: [
                [606],
                [],
                [],
                [],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    AksinyaAnalyzesAfter: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AksinyaCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAksinyaCard",
            nextClick: "aksinyaFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_aksinya_1_1_table.jpg`],
                [],
                [],
                [],
                []
            ],
            analyzesHeights: [
                [606],
                [],
                [],
                [],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1AfterQuestion: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Мой организм меня подводит: мне нужно готовиться к олимпиадам, поступать скоро, а я не могу ничего делать. Я постоянно чувствую слабость, головокружение. А вдруг болезнь и слабость затянут меня, и я не смогу поступить туда, куда хочу?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Osmotr: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Кожа", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Ногти", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пульс", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Osmotr1: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Наблюдается заметная бледность кожных покровов',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Osmotr2: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Ломкость ногтей',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Osmotr3: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Тахикардия. ЧСС - 105 уд/мин.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Mind: {
        patient: 'Aksinya',
        branch: 2,
        name: '💭 Размышления',
        text: '<i>У пациентки отмечаются бледность кожных покровов, тахикардия и общая слабость, что характерно для анемического гипоксического синдрома, обусловленного снижением кислородной ёмкости крови. Также выявлены трофические изменения — ломкость ногтей, типичные для сидеропенического синдрома.<br><br>Общий анализ крови выявил - снижение гемоглобина, гематокрита, среднего содержания и средней концентрации гемоглобина в эритроцитах, а также среднего объема эритроцитов. В совокупности эти признаки могут указывать на железодефицитную анемию (ЖДА). Для подтверждения данного диагноза необходимо провести дополнительные исследования.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit1MindLink', value: false, redColor: false, answered: false},
            {text: "Сделать назначение", type: "nextStep", gotoStep:'aksinyaVisit1Dict', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1MindLink: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Железодефицитная анемия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/669_2">https://cr.minzdrav.gov.ru/view-cr/669_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Dict: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AksinyaCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "aksinyaGematogen1",
            pages: [
                {image: `${base}/images/aksinya_teach1_1.png`, scroll: false},
                {image: `${base}/images/aksinya_teach1_2.png`, scroll: true},
                {image: `${base}/images/aksinya_teach1_3.png`, scroll: true},
            ]
        }
    },
    aksinyaGematogen1: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>А вот и награда! Держите гематогенку!</strong><br><br>🍫 Соберите 6 и более гематогенок за изучение информационных материалов — и в финале игры получите 🎁 стикерпак ГЕМАТОЛОГА!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Naznachenie', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Naznachenie: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Вы',
        text: 'Аксинья, по результатам Вашего анализа крови и Ваших жалоб можно предположить, что у Вас железодефицитная анемия (ЖДА). Для подтверждения данного диагноза я дополнительно назначаю Вам биохимический анализ крови и...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit1NaznachenieLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaTest', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1NaznachenieLink: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Железодефицитная анемия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/669_2">https://cr.minzdrav.gov.ru/view-cr/669_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Naznachenie', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaTest: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: true,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: `${base}/images/aksinya_questions1.png`,
        stepSound: '',
        rating: 0,
        buttons: [],
        question: {
            title: "Какие дополнительные <br>исследования могут назначить <br>для подтверждения железодефицитной анемии?",
            result: "ЛДГ — лактатдегидрогеназа<br>АСТ — аспартатаминотрансфераза<br>АЛТ — аланинаминотрансфераза<br><br><strong>Клинические рекомендации</strong><br>“Железодефицитная анемия” 2024. Электронный ресурс. <a href='https://cr.minzdrav.gov.ru/view-cr/669_2'>https://cr.minzdrav.gov.ru/view-cr/669_2</a><br> (дата обращения: 08.07.2025)",
            nextStep: "aksinyaTestBad",
            nextStepCorrect: "aksinyaTestGood",
            answers: [
                {name: "Уровень ферритина", correct: true},
                {name: "ОЖСС (общая железосвязывающая способность сыворотки", correct: true},
                {name: "ЛДГ", correct: false},
                {name: "Уровень трансферрина", correct: true},
                {name: "Уровень железа сыворотки крови", correct: true},
                {name: "НТЖ (насыщение трансферрина железом)", correct: true},
                {name: "АСТ", correct: false},
                {name: "Билирубин", correct: false},
                {name: "АЛТ", correct: false},
            ]
        },
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaTestBad: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AksinyaCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "aksinyaVisit1Finish",
            pages: [
                {image: `${base}/images/aksinya_teach2_1.png`, scroll: false},
            ]
        }
    },
    aksinyaTestGood: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AksinyaCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "aksinyaVisit1Correct",
            pages: [
                {image: `${base}/images/aksinya_teach2_2.png`, scroll: false},
            ]
        }
    },
    aksinyaVisit1Correct: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Finish: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'А это все поможет исключить ПНГ?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1Finish2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Finish2: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Вы',
        text: 'Для исключения диагноза ПНГ необходимо будет провести еще проточную цитометрию.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit1Finish2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit1Finish3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Finish2Link: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/695_2">https://cr.minzdrav.gov.ru/view-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit1Finish2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Finish3: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Все сдам и бегом к Вам обратно! Надеюсь, это не ПНГ...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'aksinyaVisit1Write', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit1Write: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'aksinyaVisit2Cabinet', value: false, redColor: false, answered: false, patient: 'Aksinya'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Cabinet: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep:'patientAksinyaCardSecond', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAksinyaCardSecond: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AksinyaAnalyzes2",
            closeClick: "tuktuk2Aksinya",
            pages: [`${base}/images/patient_aksinya_card1.png`, `${base}/images/patient_aksinya_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AksinyaAnalyzes2: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAksinyaCardSecond",
            nextClick: "tuktuk2Aksinya",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_aksinya_2_1_table.jpg`],
                [`${base}/images/analiz_aksinya_2_2_table.jpg`],
                [`${base}/images/analiz_aksinya_2_3_table.jpg`],
                [`${base}/images/analiz_aksinya_2_4_table.jpg`],
                []
            ],
            analyzesHeights: [
                [606],
                [519],
                [342],
                [472],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    tuktuk2Aksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Тревожный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/tuktuk.mp3`,
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enter2Aksinya', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enter2Aksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Здравствуйте! Ну что... что у меня? Все-таки ПНГ? Ох, ох, я так и знала... Скажите же скорее..',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaEnter.jpg`,
        buttons: [
            {text: "Предположить диагноз пациента", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2SetDiagnose: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Вы',
        text: 'Я понимаю ваши переживания, Аксинья, но ПНГ у вас нет.<br>По результатам анализов у вас...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "ЖДА", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose1Correct', value: false, redColor: false, answered: false, width: "calc(33.33% - 12px)"},
            {text: "ПНГ", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose2', value: false, redColor: false, answered: false, width: "calc(33.33% - 12px)"},
            {text: "АИГА", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose3', value: false, redColor: false, answered: false, width: "calc(33.33% - 12px)"},
            {text: "АХЗ - анемия хронических заболеваний", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose1Correct: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose1', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose1: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Очевидно - это железодефицитная анемия (ЖДА).</strong><br><br>У пациентки наблюдаются низкие показатели гемоглобина, гематокрита, средний объем эритроцитов и средняя концентрация гемоглобина ниже нормы. Наблюдаемые показатели метаболизма железа у пациентки характерны для ЖДА:<br><br>Сывороточное железо ↓<br>ОЖСС ↑<br>Трансферрин ↑<br>НТЖ ↓<br>Ферретин сыворотки ↓.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit2Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose2: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Диагноз ПНГ устанавливается на основании:</strong><br><ul><li>Характерной клинической и лабораторной картины внутрисосудистого гемолиза</li><li>Выявления в периферической крови ПНГ-клона методом проточной цитометрии (Иммунофенотипирование клеток периферической крови для диагностики пароксизмальной ночной гемоглобинурии расширенной панелью маркеров, включая FLAER (флюоресцентно-меченый аэролизин)</li></ul><i>Для активного внутрисосудистого гемолиза характерно повышение активности ЛДГ, общего билирубина за счет непрямой фракции, свободного гемоглобина плазмы, а также истощение гаптоглобина и появление гемосидерина в моче.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose3: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'У пациентки <strong>не наблюдается характерная клиническая и лабораторная картина АИГА.</strong><br><br>При АИГА характерны:<ol><li>Гипербилирубинемия (преобладает непрямая, неконъюгированная  фракция)</li><li>Повышение активности ЛДГ в сыворотке в 2—8 раз (в зависимости от интенсивности гемолиза)</li><li>Cнижение уровня гемоглобина, от умеренного  до 26—36 г/л, и соответствующее уменьшение количества эритроцитов при высоком  ретикулоцитозе</li></ol>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose4: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Не похоже на АХЗ.</strong><br><br>При АХЗ у пациента наблюдается иная картина показателей метаболизма железа:<ol><li>Нормальный или пониженный показатель сывороточного железа</li><li>Нормальный показатель ОЖСС</li><li>Нормальный или пониженный показатель трансферрина</li><li>Нормальный или пониженный показатель НТЖ</li><li>Нормальный или повышенный показатель ферритина сыворотки крови</li></ol>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'aksinyaVisit2Diagnose4Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose1Link: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Железодефицитная анемия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/669_2">https://cr.minzdrav.gov.ru/view-cr/669_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit2Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose2Link: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/665_2">https://cr.minzdrav.gov.ru/view-cr/665_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose3Link: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации по диагностике и лечению аутоиммунной гемолитической анемии (АИГА) у взрослых</strong><br>Национальное гематологическое общество<br><a href="https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf">https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf</a><br>(дата обращения: 11.11.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Diagnose4Link: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '<strong>Клинические рекомендации “Железодефицитная анемия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/669_2">https://cr.minzdrav.gov.ru/view-cr/669_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit2SetDiagnose', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Finish: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Точно? Я так боялась, что это ПНГ. Тогда витаминки?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Ну почти", type: "nextStep", gotoStep:'aksinyaVisit2Write', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit2Write: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Вы',
        text: 'Назначаю вам терапию и коррекцию питания. И приходите на контрольный осмотр через несколько месяцев по состоянию.<br><br>Удачи Вам на экзаменах!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet.jpg`,
        buttons: [
            {text: "Закончить прием", type: "closeTelegramBot", gotoStep:'aksinyaVisit3Cabinet', value: false, redColor: false, answered: false, patient: 'Aksinya'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Cabinet: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep:'tuktuk3Aksinya', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktuk3Aksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/tuktuk.mp3`,
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enter3Aksinya', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enter3Aksinya: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Здравствуйте, доктор! Я такая счастливая в последние дни: то ли потому что экзамены сдала, то ли потому, что выздоровела! Или, может, все вместе?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaEnter2.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите, пожалуйста.", type: "nextStep", gotoStep:'aksinyaVisit3Question', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Question: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'То, что вы себя замечательно чувствуете - это уже победа! Давайте посмотрим на Ваши анализы и проведем контрольный осмотр!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Опросить пациентку", type: "nextStep", gotoStep:'aksinyaVisit3Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'AksinyaAnalyzes3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Questions: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'aksinyaVisit3Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Одышка", type: "nextStep", gotoStep:'aksinyaVisit3Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Сон", type: "nextStep", gotoStep:'aksinyaVisit3Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Головокружение", type: "nextStep", gotoStep:'aksinyaVisit3Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3Question', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Question1: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Устаю уже только к самому вечеру! А весь день бодрая хожу!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaVisit3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Question2: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Я перестала пользоваться лифтом и теперь на 5 этаж домой бегаю вверх! Кардио!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaVisit3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Question3: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Экзамены сданы - сплю по 8 часов стабильно!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaVisit3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Question4: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Тут все в порядке! Даже если с кровати резко встаю - обычно все нормально.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'aksinyaVisit3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAksinyaCardThird: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AksinyaAnalyzes3",
            closeClick: "aksinyaVisit3Question",
            pages: [`${base}/images/patient_aksinya_card1.png`, `${base}/images/patient_aksinya_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AksinyaAnalyzes3: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAksinyaCardThird",
            nextClick: "aksinyaVisit3Question",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_aksinya_3_1_table.jpg`],
                [`${base}/images/analiz_aksinya_3_2_table.jpg`],
                [`${base}/images/analiz_aksinya_3_3_table.jpg`],
                [`${base}/images/analiz_aksinya_3_4_table.jpg`],
                []
            ],
            analyzesHeights: [
                [606],
                [519],
                [342],
                [472],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3AfterQuestion: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Osmotr: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Кожа", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Ногти", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пульс", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Osmotr1: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Нормального цвета, без сухости',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Osmotr2: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Ногти розовые, крепкие, без белых пятнышек',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Osmotr3: {
        patient: 'Aksinya',
        branch: 2,
        name: '',
        text: 'Пульс в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'aksinyaVisit3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Finish: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Вы',
        text: 'Аксинья, кажется, Ваше состояние теперь в норме. Могу пожелать Вам только удачи и отличной учебы в университете Вашей мечты.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3Finish2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Finish2: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Аксинья',
        text: 'Спасибо вам! Кстати, я решила поступать в медицинский университет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AksinyaCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'aksinyaVisit3Finish3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    aksinyaVisit3Finish3: {
        patient: 'Aksinya',
        branch: 2,
        name: 'Надя',
        text: 'Ой, как здорово! Будем ждать тебя в нашей поликлинике теперь уже не как пациентку, а как доктора! Удачи!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Закончить прием", type: "closeTelegramBot", gotoStep:'start', value: false, redColor: false, answered: false, patient: 'Julia'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

}
